import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexscreenerRockets = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Dexscreener Rockets 🚀 - #1 Rocket Reaction Service | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener Rockets 🚀 at the cheapest price! Get authentic rocket reactions from $0.05. Fastest delivery, 20% bonus, natural patterns. #1 Dexscreener rockets provider. Telegram bot available!" />
        <meta name="keywords" content="buy dexscreener rockets, dexscreener rockets, buy dexscreener reaction, buy dexscreener fire, buy dexscreener poop, dexreactions, rocket dexscreener, dexscreener rocket emoji, bullish dexscreener, buy rocket reactions, cheap dexscreener rockets" />
        <link rel="canonical" href="https://dexreaction.com/buy-dexscreener-rockets" />
        <meta property="og:title" content="Buy Dexscreener Rockets 🚀 - Cheapest Rocket Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener Rockets from $0.05! #1 bullish reaction. Instant delivery, 20% bonus free!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/buy-dexscreener-rockets" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-orange-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-orange-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Buy Rockets Now
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-orange-500/20 text-orange-300 px-6 py-3 rounded-full font-semibold mb-6">
              🚀 #1 Dexscreener Rockets Provider
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-orange-400 via-yellow-400 to-red-400 bg-clip-text text-transparent">
                Buy Dexscreener Rockets
              </span>
            </h1>
            <div className="text-8xl mb-6 animate-bounce">🚀</div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              The Most Popular Bullish Reaction on DexScreener
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Boost your token&apos;s visibility with authentic rocket reactions. Show strong upward momentum and attract more investors with our premium service.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                🚀 Buy Dexscreener Rockets
              </button>
              <button
                onClick={() => window.open('https://t.me/dexreactionrobot', '_blank')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all border border-orange-500/30"
              >
                Try Telegram Bot
              </button>
            </div>
          </div>
        </section>

        {/* Why Buy Dexscreener Rockets */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Buy Dexscreener Rockets?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '📈', title: 'Bullish Signal', desc: 'Rocket 🚀 is THE bullish reaction on DexScreener. It signals strong upward momentum and attracts more traders.' },
                { icon: '🏆', title: 'Most Popular', desc: 'Rockets are the #1 most used reaction type. High rocket counts make your token stand out instantly.' },
                { icon: '💎', title: 'Investor Magnet', desc: 'Tokens with high rocket counts attract more attention from potential investors and whales.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-orange-900/30 to-red-900/30 border border-orange-500/20 rounded-xl p-6 text-center hover:border-orange-500/50 transition-all">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Rocket Pricing */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Dexscreener Rockets Pricing
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Just $0.05 per rocket reaction + 20% Bonus FREE
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600, label: 'Starter' },
                { qty: 1000, price: 50, total: 1200, label: 'Popular', popular: true },
                { qty: 1500, price: 75, total: 1800, label: 'Pro' },
                { qty: 2000, price: 100, total: 2400, label: 'Enterprise' }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-orange-900/30 to-red-900/30 border-2 ${pkg.popular ? 'border-orange-500' : 'border-orange-500/30'} rounded-xl p-6 hover:border-orange-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 py-1 rounded-full text-sm font-bold">Most Popular</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="text-sm text-orange-400 font-semibold mb-2">{pkg.label}</div>
                    <div className="text-4xl mb-2">🚀</div>
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-4">Rockets</div>
                    <div className="text-4xl font-bold text-orange-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-2 mb-4">
                      <span className="text-green-400 font-semibold">Get {pkg.total} total (+20%)</span>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Buy Rockets
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Benefits of Dexscreener Rockets
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { icon: '🎯', title: 'Trending Boost', desc: 'Rocket reactions directly influence DexScreener trending algorithms' },
                { icon: '⚡', title: 'Instant Delivery', desc: 'Your rockets start delivering immediately after payment' },
                { icon: '🔒', title: 'Safe & Natural', desc: 'Natural delivery patterns - 500 rockets per 10 minutes' },
                { icon: '💰', title: 'Best Value', desc: 'Lowest price at $0.05/rocket with 20% bonus free' },
                { icon: '🤖', title: 'Telegram Bot', desc: 'Order rockets easily via our Telegram bot' },
                { icon: '24/7', title: 'Always Available', desc: '24/7 automated service with instant processing' }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <div className="text-3xl flex-shrink-0">{item.icon}</div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How to Buy */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How to Buy Dexscreener Rockets
            </h2>
            <div className="space-y-6">
              {[
                { step: 1, title: 'Choose Rocket Package', desc: 'Select how many rockets you want. All packages include 20% bonus rockets free.' },
                { step: 2, title: 'Enter Token Link', desc: 'Provide your DexScreener token link where rockets will be delivered.' },
                { step: 3, title: 'Pay with Solana', desc: 'Complete secure payment using Solana (SOL) via wallet or manual transfer.' },
                { step: 4, title: 'Get Your Rockets!', desc: 'Rockets start delivering immediately at 500 per 10 minutes.' }
              ].map((item) => (
                <div key={item.step} className="flex gap-4 bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center text-xl font-bold">
                    {item.step}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Dexscreener Rockets FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'What are Dexscreener Rockets?', a: 'Rockets 🚀 are the most popular bullish reaction on DexScreener. They signal strong upward momentum and community confidence in a token.' },
                { q: 'How fast are rockets delivered?', a: 'Rockets start delivering immediately after payment. We deliver 500 rockets every 10 minutes for natural-looking growth.' },
                { q: 'Is buying rockets safe?', a: 'Yes! We use authentic accounts and natural delivery patterns. Your token will not be flagged or penalized.' },
                { q: 'Why choose rockets over other reactions?', a: 'Rockets are the #1 bullish signal. High rocket counts attract investors and improve trending rankings more than other reactions.' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-orange-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2 text-orange-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Buy Dexscreener Rockets?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join hundreds of successful tokens using our rocket service
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              🚀 Buy Dexscreener Rockets Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-orange-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-orange-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-orange-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-orange-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexscreenerRockets;
